export enum GrantType {
  PASSWORD = 'password',
  REFRESH = 'refresh_token',
  PASSWORD_DEVICE = 'password_device'
}
export enum TOKEN_TYPE_HINT {
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token'
}
export enum SourceDeviceType {
  WEB = 'web',
  MOBILE = 'mobile'
}
class TokenRequest {
  grantType: GrantType
  refreshToken: string
  uuid: string
  device: string
}

export class LoginRequest extends TokenRequest {
  user: string
  domain: string
  password: string
  rememberme: boolean
  sourceDevice: string
}

/*eslint-disable */
export class LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
  refresh_token: string
  needResetpwd?: boolean
}

export type RecoveryPassword = 'recoveryPassword'
export type FirstLoginRecovery = 'fisrtLogin'
export type ExpirationPwdRecovery = 'expirationPwd'
export type RecoveryReasons = RecoveryPassword | FirstLoginRecovery | ExpirationPwdRecovery
